import { popupSurface } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'
import type { MentionSection } from '../hooks/use-filtered-mention-data'

/**
 * The parts both mention lists share. The inline list (queried from the composer) and the
 * Combobox (opened from the @ button, with its own search field) differ only in who owns the
 * highlight and the keys, so everything they show comes from here and from `MentionRowContent`.
 */

/** The popup both lists sit in. */
export const mentionsPopupClassName = twMerge(popupSurface, 'w-fit min-w-56 max-w-[21rem]')

/** A section's label, with a link to the full page when it has one. */
export const MentionSectionHeading = ({ section }: { section: MentionSection }) => (
  <>
    {section.label}
    {section.linkToPage && (
      // `window.open`, not an anchor: it is the renderer path the main process routes `highlight://`
      // links through (WindowManager.bindOpenUrlHandlers).
      <button
        type="button"
        onClick={() => window.open(section.linkToPage, '_blank')}
        className="hover:text-foreground cursor-pointer appearance-none border-0 bg-transparent p-0 text-inherit underline [font:inherit]"
      >
        View all
      </button>
    )}
  </>
)
